<template>
  <Section>
    <Container>

      <div class="text-center mx-auto max-w-2xl">
        <div class="mb-2 md:mb-4" v-if="content.pretitle">
          <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
            {{ content.pretitle }}
          </span>
        </div>
        <h2 class="text-section-title" v-if="content.title">{{ content.title }}</h2>
        <p class="text-subtitle" v-if="content.subtitle">{{ content.subtitle }}</p>
      </div>

      <div class="mt-12 md:mt-16 md:flex">
        <div
        class="md:w-[60%]"
        :class="content.text_on_right ? 'md:order-first md:pr-8 lg:pr-12' : 'md:order-last md:pl-8 lg:pl-12'"
        >
          <div
          v-for="(item, index) in content.items"
          :class="activeIndex === index ? 'block' : 'hidden'"
          >
            <LottiePlayer
            v-if="item.features_item_id?.lottie"
            :src="`https://media.elker.com/${item.features_item_id.lottie.id}/${item.features_item_id.lottie.filename_download}`"
            wrapper-class="rounded-xl overflow-hidden"
            />
            <div 
            v-else-if="item.features_item_id.image"
            class="aspect-[535/355] rounded-xl overflow-hidden"
            >
              <img
              :src="useCdn(item.features_item_id.image.id, item.features_item_id.image.filename_download)"
              :alt="`${item.features_item_id.title} with Elker`"
              class="object-cover w-full h-full"
              loading="lazy"
              >
            </div>
          </div>
        </div>
        <div 
        class="md:w-[40%]"
        :class="content.text_on_right ? 'md:order-last' : 'md:order-first'"
        >
          <div 
          v-for="(item, index) in content.items" 
          class="relative border-b border-[#e8e5de] py-4 md:py-6 cursor-pointer"
          @click="activeIndex = index"
          >
            <div class="font-bold text-gray-900 text-lg">{{ item.features_item_id.title }}</div>
            <div 
            class="mt-2"
            :class="activeIndex === index ? 'block' : 'hidden'"
            >{{ item.features_item_id.subtitle }}</div>
          </div>
        </div>

      </div>

    </Container>
  </Section>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})

const activeIndex = ref(0)
</script>
